import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-previous",
  "use": "icon-previous-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-previous\"><title>icon-previous</title><path fill=\"currentColor\" d=\"M80.988 243.408l125.969-125.962L195.51 106 50 251.502 195.51 397l11.447-11.446L80.988 259.596H450v-16.188z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol